module.exports = __webpack_public_path__ + "static/media/p8_img7.e97028e1.svg";